class PaypalMarketPlaceRequest {

    config: any;
    currentAmount; Function;
    isOrderFulfilled: Function;

    constructor(config: any, getPayAmount: Function, isOrderFulfilled: Function) {
        this.config = config;
        this.currentAmount = () => {
            return getPayAmount();
        }
        this.isOrderFulfilled = isOrderFulfilled;

        this.init();
    }

    init() {
        const { environment, demoMode, isoCurrencySymbol, paymentDescription, goalType, goalTypeInt, interactionId } = this.config.general;
        const { transactionID } = this.config.paypal;
        const currentAmount = this.currentAmount;
        let { redirectUrl } = this.config.general;
        let orderID: string;

        (<any>window).paypal.Button.render({
            env: environment,
            commit: true,
            style: {
                size: 'responsive',
                color: 'blue',
                shape: 'rect',
                label: 'checkout'
            },
            payment: () => {
                const data = `amount=${currentAmount().value}&interactionId=${interactionId}&transactionId=${transactionID}&demo=${demoMode}&currency=${isoCurrencySymbol}&paymentDescription=${paymentDescription}`;
                const url = `../PayPalMarketplace/CreateOrder?${data}`;


                return (<any>window).paypal.request.post(url)
                    .then((response) => {
                        const { statusCode, orderId, errorMessage } = response;

                        if (statusCode === 200) {
                            orderID = orderId;
                            return orderId;
                        } else {
                            const errorEl: HTMLElement = document.getElementById('error');
                            document.body.classList.remove('whirl', 'ringed');
                            errorEl.innerHTML = `${errorMessage[0]}`;
                        }
                    })
            },
            onAuthorize: () => {
                const dataToSend = `interactionId=${interactionId}&orderId=${orderID}&demo=${demoMode}&paymentDescription=${paymentDescription}&goalType=${goalTypeInt}`;
                const url = `../PayPalMarketplace/PayForOrder?${dataToSend}`;

                document.body.classList.add('whirl', 'ringed');

                return (<any>window).paypal.request.post(url)
                    .then((response) => {
                        const { statusCode, billingData, errorMessage } = response;

                        //redirectUrlPaypal += redirectUrlPaypal.includes("?") ? "&" : "?";
                        redirectUrl += `&donationAmount=${currentAmount().value}&email=${billingData?.email}`;

                        if (statusCode === 200) {
                            let userInfo = JSON.parse(localStorage.getItem("GiftAid_Info"));

                            if (billingData != null && userInfo == null) {
                                userInfo = {
                                    'title': "",
                                    'forename': billingData.first_name,
                                    'surname': billingData.last_name,
                                    'addressline': billingData.shipping_address.line1,
                                    'postcode': billingData.shipping_address.postal_code
                                };
                                localStorage.setItem("GiftAid_Info", JSON.stringify(userInfo));
                            }
                            this.isOrderFulfilled();

                            window.location.href = redirectUrl;
                        } else {
                            const errorEl: HTMLElement = document.getElementById('error');
                            document.body.classList.remove('whirl', 'ringed');
                            errorEl.innerHTML = "Payment failed. Please try again.";

                            if (goalType === "FULFILMENT_MENU") {
                                const errorMenuElement: HTMLElement = document.getElementById('menuError');
                                errorMenuElement.style.display = "block";
                            }
                        }
                    })
            },
            //onError: (err) => {
            //    console.log(err);
            //}
        }, '#paypal-button');
    }
}

export default PaypalMarketPlaceRequest;